import { plural } from '@cian/utils';

import { ETransportType } from '../repositories/favorites/entities/favorite_entity_for_desktop/UndergroundInfoForDesktopSchema';
import { EEntityType, EFavoriteEntityType } from '../types/filters';

export function convertToFavoriteEntityType(entityType: EEntityType): EFavoriteEntityType {
  const map = {
    [EEntityType.Commercial]: EFavoriteEntityType.Commercial,
    [EEntityType.Residential]: EFavoriteEntityType.Flat,
    [EEntityType.Suburban]: EFavoriteEntityType.Suburban,
    [EEntityType.Newbuilding]: EFavoriteEntityType.JK,
  };

  return map[entityType];
}

export function getTimeTransportTextForUnderground(time: number, transportType: ETransportType): string {
  const mapTransportType = {
    walk: 'пешком',
    transport: 'на транспорте',
  };

  return `${time} ${plural(time, ['минута', 'минуты', 'минут'])} ${mapTransportType[transportType]}`;
}

export function getDeletedDateString(deleteDate: string): string {
  const date = new Date(deleteDate);

  const dayRaw = date.getDate();
  const day = dayRaw < 10 ? `0${dayRaw}` : dayRaw;

  const monthRaw = date.getMonth() + 1;
  const month = monthRaw < 10 ? `0${monthRaw}` : monthRaw;

  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
}

export function getTextCount(count: number) {
  return count ? `${count} ${plural(count, ['объявление', 'объявления', 'объявлений'])}` : 'Нет объявлений';
}
